<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <el-button type="primary" class="elm-but" icon="el-icon-arrow-left" @click="$router.go(-1)">返回列表</el-button>
      </div>
      <div class="flex" style="margin-top: 20px;padding: 20px;align-items: end;">
        <div style="width:40%" class="timeline">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in commentsList" :key="index" :timestamp="item.datetime"
              placement="top">
              <el-card>
                <h3 style="margin: 0;">用户：{{ item.user }}</h3>
                <p style="margin-top: 10px">
                  操作：{{ item.operateType }}
                </p>
                <p style="margin-top: 10px;" v-if="item.content != null && item.content != ''">
                  备注：{{ item.content }}
                </p>
                <img v-image-preview class="img-style" v-for="(img, j) in item.uploadImages"  :key="j" :src="global.imgSrc + img.filePath"  />
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div style="width:50%">
          <div class="k_b1">
            <i class="k_top_left"></i>
            <i class="k_top_right"></i>
            <i class="k_bottom_left"></i>
            <i class="k_bottom_rigth"></i>
            <div class="k_b2">
              <b class="k_b3">[</b>
              <span style="padding: 0px 10px;">工单详情</span>
              <b class="k_b3">]</b>
            </div>
            <div class="k_padding">
              <div><span class="title_span">站点类别：<span>{{data.siteType == 1 ? "厕所" : data.siteType == 2 ? "泵站" : data.siteType == 3 ? "传感器":data.siteType == 4 ? "除臭机" : (data.siteType == 5 ? "意见反馈" : "其他")}}</span></span></div>
              <div><span class="title_span">站点名称：<span>{{data.siteName}}</span></span></div>
              <div><span class="title_span">问题描述：<span>{{data.alarmContent == '' ? '暂无' : data.alarmContent}}</span></span></div>
              <div><span class="title_span">工单状态：<span>{{global.workOrderStart(data.status)}}</span></span></div>
              <div><span class="title_span">处理人员：<span>{{data.principal == null ? "暂无" : data.principal}}</span></span></div>
              <div><span class="title_span">上传图片：<span v-if="data.images == '' || data.images == null">暂无</span></span>
                <img v-image-preview class="img-style" v-for="(item, index) in images" :key="index" :src="global.imgSrc + item.filePath" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    components: {},
    data() {
      return {
        data: {},
        commentsList: [],
        images:[]
      };
    },
    methods: {
      getList() {
        this.loading = true;
        this.get("operation/management/workorderDetails", { id: this.$route.query.id }).then(
          (res) => {
            this.data = res.data.data;
            this.commentsList = JSON.parse(res.data.data.comments);
            this.commentsList.forEach(e => {
              if(e.uploadImages) {
                e.uploadImages = JSON.parse(e.uploadImages);
              }
            });
            if(res.data.data.images){
              this.images = JSON.parse(res.data.data.images)
            }
          });
      },


    },
    mounted() {
      this.getList();
    },
  };
</script>

<style scoped>
  .timeline /deep/ .el-card {
    border: none;
    color: #000;
  }

  .k_padding div {
    margin-bottom: 20px;
  }

  h4 {
    margin: 0px;
  }

  .title_span {
    font-size: 15px;
    font-weight: 600;
  }

  .title_span span {
    font-weight: 100;
  }

  .img-style{
    width: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/menu/maintenance/workOrderDetails.vue